import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { Login } from "../Componant/organisms/Login";
import { DashboardRoute, LoginRoute, UserManagementRoute } from "../utils/Constant";
import { authRoutes } from "./AuthRoutes";
import LayoutRoutes from "./LayoutRoutes";
import PrivateRoute from "./PrivateRoute";

const RouterData = () => {
  const login = localStorage.getItem("adminToken");

  return (
    <BrowserRouter>
      <Routes>
        {login ? (
          <>
            <Route
              path={"/"}
              element={<Navigate to={`/${UserManagementRoute}`} />}
            />
          </>
        ) : (
          <Route path={"/"} element={<Navigate to={`/${LoginRoute}`} />} />
        )}
        <Route path={"/"} element={<PrivateRoute />}>
          <Route path={`/*`} element={<LayoutRoutes />} />
        </Route>
        {authRoutes.map(({ path, Component }, i) => (
          <Route path={path} element={Component} key={i} />
        ))}
        <Route path={`/login`} element={<Login />} />
      </Routes>
    </BrowserRouter>
  );
};

export default RouterData;
